module.exports = __webpack_public_path__ + "img/mirakl.62657679.png";